import { getPanel } from '../panels'

// The panel host: renders the single active panel from the registry. Placement (desktop side
// column vs mobile full-screen swap) is owned by AppShell + CSS (.panel-host-col); this just
// resolves the active panel id → its body. Keeping render here means a panel plugin never
// reimplements the responsive frame. See PLUGIN_MODULES.md → Contribution Points (panel).
interface PanelHostProps {
  activePanelId: string
  chatId: string
  workspaceId?: string
  onClose: () => void
}

export function PanelHost({ activePanelId, chatId, workspaceId, onClose }: PanelHostProps) {
  const panel = getPanel(activePanelId)
  if (!panel) return null
  return <>{panel.render({ chatId, workspaceId, onClose })}</>
}
